(ns practitest.frontend.components2.run-status
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.common.i18n :refer [get-translation]]))

(def no-run-status "NO RUN")

(def statuses-map
  {"PENDING"       {:label (get-translation "run-status.pending" "Pending")
                    :color "var(--pt-color-status-pending)"}
   "RUNNING"       {:label (get-translation "run-status.running" "Running")
                    :color "var(--pt-color-status-running)"}
   "PASSED"        {:label (get-translation "run-status.passed" "Passed")
                    :color "var(--pt-color-success)"}
   "FAILED"        {:label (get-translation "run-status.failed" "Failed")
                    :color "var(--pt-color-error)"}
   "CANCELED"      {:label (get-translation "run-status.canceled" "Canceled")
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:label (get-translation "run-status.error" "Error")
                    :color "var(--pt-color-status-error)"}
   no-run-status   {:label (get-translation "run-status.no-run" "No Run")
                    :color "var(--pt-color-status-no-run)"}
   "NOT INCLUDED"  {:label (get-translation "run-status.not-included" "Not Included")
                    :color "var(--pt-color-border-light)"}
   "BLOCKED"       {:label (get-translation "run-status.blocked" "Blocked")
                    :color "var(--pt-color-status-blocked)"}
   "NOT COMPLETED" {:label (get-translation "run-status.not-completed" "Not Completed")
                    :color "var(--pt-color-status-not-completed)"}
   "N/A"           {:label (get-translation "run-status.na" "N/A")
                    :color "var(--pt-color-status-na)"}})

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        (str "UNMAPPED STATUS " status))))

(defn get-status-color
  ([status]
   (get-status-color status false))
  ([status is-et]
   (let [status-colors @(re-frame/subscribe [::subs/status-colors])]
     (if is-et (get status-colors status) (:color (get statuses-map status))))))

(defn run-status-component
  [status]
  [:<>
   [:span.status-indicator
    {:style {:color (get-status-color status)}}]
   (get-status-label status)])
